var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClean = function SvgClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 107,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m105.093 49.17-8.096 4.672c-5.86-5.091-10.473-13.077-11.946-20.695l8.089-4.67c1.48 7.617 6.093 15.602 11.953 20.687v.007Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m93.145 28.483-8.09 4.67-39.592-22.858 8.095-4.671 39.587 22.859Z",
    fill: "#969A9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.684 76.733c0 9.188-2.661 14.285-7.417 17.025l-7.779 4.49c4.555-2.785 7.1-7.863 7.1-16.844l.408-27.562 8.095-4.671-.407 27.562Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m79.125 52.563 5.595 9.704-21.74 12.54-14.964-25.914 5.595-3.237 9.368 16.217 16.146-9.31Z",
    fill: "#3ED1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m89.495 98.248-.078.045c-5.485 3.308-13.84 3.334-24.157 2.869-18.963-21.037-31.33-36.136-31.33-55.94l-.407-28.027c4.872 1.39 8.878-.213 10.939-4.193a11.87 11.87 0 0 0 1.001-2.707L85.05 33.154c1.473 7.617 6.087 15.603 11.947 20.694l-.407 27.563c0 8.98-2.546 14.058-7.1 16.843l.005-.006ZM84.72 62.267l-5.602-9.705-16.14 9.31-9.367-16.216-5.602 3.237 14.97 25.914 21.74-12.54Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.619 12.524c.982.278 1.938.44 2.843.485-2.061 3.98-6.067 5.582-10.939 4.193l8.096-4.671v-.007Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.495 98.248c4.554-2.785 7.1-7.863 7.1-16.844l.407-27.562c-5.86-5.092-10.473-13.077-11.946-20.695L45.463 10.295a12.388 12.388 0 0 1-1.001 2.707c-2.061 3.98-6.067 5.582-10.939 4.193l.407 28.028c0 19.796 12.367 34.902 31.33 55.939 10.311.465 18.672.439 24.157-2.87",
    stroke: "#000",
    strokeWidth: 1.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m89.178 98.435 8.089-4.671c4.755-2.746 7.417-7.844 7.417-17.025l.407-27.562C99.237 44.086 94.618 36.1 93.138 28.489L53.558 5.624l-8.095 4.671M44.462 13.009c-.905-.04-1.86-.2-2.843-.485l-8.096 4.678M93.144 28.483l-8.09 4.67M105.091 49.17l-8.089 4.678",
    stroke: "#000",
    strokeWidth: 1.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m84.72 62.267-5.595-9.704-16.146 9.31-9.368-16.217-5.595 3.237 14.963 25.915L84.72 62.267Z",
    stroke: "#000",
    strokeWidth: 1.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgClean;